const LOGO_BASE_PATH =
  '/wp-content/themes/sef-leagues/images/{abbrv}-team-logo.png"';

export const getTeamHeroInformation = (teamData) => {
  return {
    name: teamData.name,
    // logoImageUrl: LOGO_BASE_PATH.replace('{abbrv}', 'AIK'), //CHANGE TO ABBRV FROM TEAMDATA!
    logoImageUrl: teamData.logo,
    leagueAndSeason: 'ALLSVENSKAN 2023',
    headerImageUrl: teamData.headerImageUrl
  };
};
